export const sendCounter = (id: string) => {
    if (!id) {
        return;
    }

    new Image().src = `//rs.mail.ru/d${id}.gif?rnd=${Math.random()}`;
};
